import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {RefillsHandlerService} from '../../../../api-handlers/refills-handler.service';
import {AuthService} from '../../../../auth-n-routing/auth-service.service';
import {DateHandlerService} from '../../../../commons/date-handler.service';

@Component({
	selector: 'app-ref-filter',
	templateUrl: './ref-filter.component.html',
	styleUrls: ['./ref-filter.component.css']
})
export class RefFilterComponent implements OnInit {
	@Output() reloadRequested = new EventEmitter();

	dom_elements = {
		data_inizio_enabled: false,
		data_fine_enabled: false,
		filtro_attivo: 'Filtra per...',
		statuses: [ 'Tutte', 'Pendenti', 'Rifiutate', 'Approvate' ]
	};

	constructor(public refillsHandlerService: RefillsHandlerService,
				public dateHandlerService: DateHandlerService,
				public authService: AuthService) { }

	ngOnInit() {
		this.refillsHandlerService.filterNameUpdateRequired.subscribe(( value ) => {
			this.dom_elements.filtro_attivo = value;
		});
	}

	filterColumnChanged(campo: string) {
		this.refillsHandlerService.refills_list_props.filter_column = campo;
		if (campo === 'refills_expanded.vhc_plate') {
			this.dom_elements.filtro_attivo = 'Targa';
		} else if (campo === 'refills_expanded.usr_name') {
			this.dom_elements.filtro_attivo = 'Nome';
		}
		// this.refillsHandlerService.refills_list_props.filter_value = '';
		if (this.refillsHandlerService.refills_list_props.filter_value !== '') {
			this.reloadRequested.next(undefined);
		}
	}

	filterValueChanged(event) {
		console.log(event.target.value);
		if (event.target.value.length > 2) {
			this.reloadRequested.next(undefined);
		} else if (event.target.value.length === 0) {
			this.reloadRequested.next(undefined);
		}
	}

	resetFilter() {
		this.dom_elements.filtro_attivo = 'Filtra per...';
		this.refillsHandlerService.refills_list_props.filter_column = '';
		this.refillsHandlerService.refills_list_props.filter_value = '';
		
		this.reloadRequested.next(undefined);
	}

	statoFilterChanged(stato: number) {
		this.refillsHandlerService.refills_list_props.status_attivo = stato;
		this.refillsHandlerService.refills_list_props.current_page = 1;
		this.reloadRequested.next(undefined);

	}

	startDateChanged(newDate: Date) {
		this.refillsHandlerService.refills_list_props.data_inizio = newDate;
		this.reloadRequested.next(undefined);

	}

	endDateChanged(newDate: Date) {
		this.refillsHandlerService.refills_list_props.data_fine = newDate;
		this.reloadRequested.next(undefined);
	}

	endDateUnchecked() {
		this.refillsHandlerService.refills_list_props.data_fine = null;
		this.reloadRequested.next(undefined);
	}

	startDateUnchecked() {
		this.refillsHandlerService.refills_list_props.data_inizio = null;
		this.reloadRequested.next(undefined);
	}



}
